import {
  Component,
  ComponentFactoryResolver, ElementRef, EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit, Output,
  Type,
  ViewChild
} from '@angular/core';
import {ContainerRefDirective} from "../../_directives/container-ref.directive";

@Component({
  selector: 'app-flying-container',
  templateUrl: './flying-container.component.html',
  styleUrls: ['./flying-container.component.scss']
})
export class FlyingContainerComponent implements OnInit {

  @Input() item!: Type<any>;
  @Input() data!: any;
  @Output() done = new EventEmitter<any>();

  @ViewChild(ContainerRefDirective, {static: true}) appContainerRef!: ContainerRefDirective;

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(ev: MouseEvent): void {
    if (this.elementRef) {
      this.elementRef.nativeElement.style.left = `${ev.pageX}px`;
      this.elementRef.nativeElement.style.top = `${ev.pageY - 50}px`;
    }
  }

  constructor(
    private elementRef: ElementRef,
    private componentFactoryResolver: ComponentFactoryResolver) {
  }

  ngOnInit(): void {
  }

  public show(): void {
    if (this.elementRef) {
      this.elementRef.nativeElement.style.display = 'flex';
      this.loadComponent();
    }
  }

  public hide(): void {
    if (this.elementRef) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }

  private loadComponent(): void {
    if (!this.appContainerRef) {
      return;
    }

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.item);
    const viewContainerRef = this.appContainerRef.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    componentRef.instance.data = this.data;
    componentRef.instance.done = this.done.emit;
  }
}
